import { createSlice } from '@reduxjs/toolkit';
import { downloadImage, getPublicCustomerVoucher, getPublicTenantsByChain } from './thunk';

export const initialState = {
  tenants: [],
  publics: [],
  images: [],
};

const PublicSlice = createSlice({
  name: 'Public',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPublicTenantsByChain.fulfilled, (state: any, action: any) => {
      state.tenants = action.payload;
    });
    builder.addCase(getPublicCustomerVoucher.fulfilled, (state: any, action: any) => {
      state.publics = action.payload;
    });
    builder.addCase(downloadImage.fulfilled, (state: any, action: any) => {
      state.images = action.payload;
    });
  },
});

export default PublicSlice.reducer;
